import { customAlphabet } from "nanoid";

const nanoid = customAlphabet("1234567890abcdefghijklmnopqrstuvwxyz", 10);
export const DIAGNOSIS_CODE = nanoid();

export const DIAGNOSIS_CODE_SENTRY_KEY = "diagnosisCode";
